//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IInstagramAudienceMetricsDateTimeResponse } from '@apis/gateway-instagram/instagramAudienceMetricsModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeEarliestAudienceInsightDate = (
  item: Serialized<IInstagramAudienceMetricsDateTimeResponse>,
): IInstagramAudienceMetricsDateTimeResponse => ({
  dateTime: item.dateTime ? new Date(item.dateTime) : undefined,
});
